import { FormSheetService } from './form-sheet.service';

export default angular
  .module('sfMobile.services.form-sheet', [
    'pascalprecht.translate',
    'sfMobile.services.action-sheet',
  ])
  .factory('formSheetService', FormSheetService).name;
